module.exports = require('./helpers/bundle-url').getBundleURL('6ZipN') + "logo-dark.eefe0b7f.svg";